import React, { useState, useMemo } from "react";
import { BsArrowDownUp } from "react-icons/bs";
import formatDateString from '../../components/utils/DateFormate';
import DetailModal from "../../components/Common/DetailModal";

const CollectionFetchTable = ({ currentPosts, handleCheckboxChange, selectedIds, selectAll, handleSelectAll }) => {
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [idDetails, setIdDetails] = useState([]);
  const [showIdModal, setShowIdModal] = useState(false);
  const [idLoading, setIdLoading] = useState(false);
  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortDirection((prevSortDirection) =>
        prevSortDirection === "asc" ? "desc" : "asc"
      );
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedData = useMemo(() => {
    const sortedArray = [...currentPosts];

    if (sortColumn !== "") {
      sortedArray.sort((a, b) => {
        const valueA = a[sortColumn];
        const valueB = b[sortColumn];

        if (sortColumn === "lastmodified") {
          // Convert timestamps to Date objects for comparison
          const dateA = new Date(valueA).getTime();
          const dateB = new Date(valueB).getTime();

          if (dateA < dateB) return sortDirection === "asc" ? -1 : 1;
          if (dateA > dateB) return sortDirection === "asc" ? 1 : -1;
          return 0;
        } else {
          if (valueA < valueB) return sortDirection === "asc" ? -1 : 1;
          if (valueA > valueB) return sortDirection === "asc" ? 1 : -1;
          return 0;
        }
      });
    }

    return sortedArray;
  }, [currentPosts, sortColumn, sortDirection]);

  // Fetch ID details
  const openIdDetails = async (row) => {
    setShowIdModal(true);
    setIdLoading(true);
    try {
      setIdDetails(row || []);
    } catch (err) {
      setIdDetails([]);
    } finally {
      setIdLoading(false);
    }
  };

  return (
    <>
      <div className="mb-2 mt-2">
        <table id="" className="table table-bordered" style={{ color: "#222" }}>
          <thead className="">
            <tr>
              <th className="width-2p text-center" scope="row">
                <input
                  id="collection-table-checkbox"
                  type="checkbox"
                  checked={
                    currentPosts.length > 0 &&
                    currentPosts.every(item => selectedIds.includes(item.id))
                  }
                  onChange={handleSelectAll}
                />
              </th>
              {/* <th onClick={() => handleSort("id")} className="width-3p text-center" scope="col">
                SN{" "} <b><BsArrowDownUp /></b>
              </th> */}
              <th onClick={() => handleSort("id")} className="width-4p text-center" scope="col">
                id{" "} <b><BsArrowDownUp /></b>
              </th>
              {/* <th className="width-12p" scope="col">
                Source Text
              </th> */}
              <th className="width-15p" scope="col">
                Clean Text
              </th>
              {/* <th className="width-7p" scope="col">
                source MD5
              </th> */}
              <th className="width-12p" scope="col">
                Clean MD5
              </th>
              <th className="width-7p" scope="col">
                Current URL
              </th>
              {/* <th className="width-2p" scope="col">
                Size
              </th> */}

              <th
                onClick={() => handleSort("lastmodified")}
                className="width-6p text-center"
                scope="col"
              >
                Date{" "}<b> <BsArrowDownUp /></b>
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((myData, index) => (
              <tr key={myData.id} style={{ backgroundColor: selectedIds.includes(myData.id) ? '#c1d3f0' : '' }}>
                <td className="">
                  <div className="custom-control custom-checkbox text-center"
                    style={{ 'whiteSpace': 'pre-wrap', wordWrap: "break-word", overflow: "hidden" }}
                  >
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id={`customCheck${myData.id}`}
                      checked={selectedIds.includes(myData.id) || selectAll}
                      onChange={() => handleCheckboxChange(myData.id)}
                    />
                  </div>
                </td>
                {/* <td className="text-center width-4p wrap-text">{index + 1}</td> */}
                <td className="text-center wrap-text">{myData.id}</td>
                {/* <td className="wrap-text">
                  <div> {myData.srctxt} </div>
                </td> */}
                <td className="">
                  <div> {myData.cleantxt} </div>
                </td>
                {/* <td className="wrap-text">
                  {myData.srcmd5}
                </td> */}
                <td className="wrap-text">
                  <strong
                    className="text-primary"
                    style={{ cursor: 'pointer' }}
                    onClick={() => openIdDetails(myData)}
                  >
                    {myData.cleanmd5}
                  </strong>
                </td>
                <td className="wrap-text">
                  {myData.cur_url.split("/").at(-1).length > 0
                      ? myData.cur_url.split("/").at(-1)
                      : myData.cur_url}{" "}
                </td>
                {/* <td className="wrap-text">
                  <div> {myData.len} </div>
                </td> */}
                <td className="wrap-text">
                  <div className="text-center">{formatDateString(myData.reqdate)}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <DetailModal
        show={showIdModal}
        title={`Details:`}
        data={idDetails}
        loading={idLoading}
        onClose={() => setShowIdModal(false)}
      />
    </>
  );
};

export default CollectionFetchTable;
